module.exports = __webpack_public_path__ + "static/img/how-get-credit-2.f5365ba9.svg";